
import { defineComponent, computed, ref, watch, nextTick, PropType } from 'vue'
import FactorItem from './FactorItem.vue'

export default defineComponent({
  name: 'FactorGroup',
  components: { FactorItem },
  props: {
    group: { type: Object as PropType<any>, required: true },
    depth: { type: Number, default: 0 },
    selectedCodes: { type: Object as PropType<Set<string>>, required: true },
    selectedMap: { type: Object as PropType<Map<string, any>>, default: () => new Map() },
    isLight: Boolean,
    colors: { type: Object as PropType<Record<string, string>>, required: true },
    headers: { type: Object as PropType<Record<string, string>>, default: () => ({}) },
    highlightCode: { type: String, default: '' }
  },
  emits: ['toggle', 'openDesc'],
  setup(props) {
    const groupEl = ref<HTMLElement | null>(null)

    // 因子说明：当前分组下直接子因子（attrType 有值）的 attrDesc 合集
    const groupDesc = computed(() => {
      const descs = (props.group.childAttrList || [])
        .filter((c: any) => c.attrType !== null && c.attrType !== undefined && c.attrDesc)
        .map((c: any) => c.attrDesc as string)
      return descs.join('；')
    })

    watch(() => props.highlightCode, (code) => {
      if (!code) return
      nextTick(() => {
        const el = groupEl.value?.querySelector(`[data-code="${code}"]`) as HTMLElement
        el?.scrollIntoView({ behavior: 'smooth', block: 'center' })
      })
    })

    return { groupEl, groupDesc }
  }
})
